<template>
  <div v-if="!this.loading" class="flex-column full-width full-height padding-m align-center margin-top-s">
    <img :src="require('@/assets/super-discount/thumbsup.png')" style="max-width: 180px">
    <div class="ri-large-headline margin-top-s">מעולה, השובר שלך מוכן</div>

    <div class="margin-top-l padding-m voucher-card">
      <img :src="require('@/assets/super-discount/rami-logo.png')" style="height: 18px" />
      <div class="ri-large-bold-body margin-top-xxs">תו קנייה ״התו המלא״ בשווי {{ voucher.worth | shekel }}</div>
      <div class="ri-label margin-top-m">זה הקוד שלך</div>
      <div class="voucher-code margin-top-xxs full-width flex-row justify-content-center align-center">
        <span class="voucher">{{voucher.voucher}}</span>
        <copy-text class="margin-top-xxs margin-right-xs" :copy-content="voucher.voucher" />
      </div>
    </div>

    <div class="ri-large-body margin-top-m">בדקות הקרובות נשלח לך את הקוד גם בוואטסאפ.</div>

    <div class="ri-label margin-top-xl flex-row align-center full-width">
      <img src="/images/info-icon-blue.svg"/>
      <span class="margin-right-s">איך להשתמש בקוד באתר רמי לוי?</span>
      <span class="ri-bold-label link margin-right-xxs" @click="readMore">אפשר לקרוא כאן</span>
    </div>
  </div>
</template>

<script>
import BillyApi from '@/api/BillyApi';
import LoadingPopup from '@/base-components/onboarding/LoadingPopup.vue';
import { mapActions } from 'vuex';
import Segment from '@/Segment';
import router from '@/router';
import CopyText from './CopyText';

export default {
  name: 'VoucherPurchasedCompletedPage',
  components: { CopyText },
  data() {
    return {
      loading: true,
      error: false,
      voucher: undefined,
    };
  },
  async created() {
    Segment.trackUserGot('RamiLevi_PurchaseCompleted_Entered');

    this.openModal({
      component: LoadingPopup,
      popupAlignment: 'center',
    });
    this.resetAppHeaderProps();

    const { state: paymentRecordId } = this.$route.query;
    if (!paymentRecordId) {
      Segment.trackUserGot('RamiLevi_PurchaseCompleted_Error', { errorType: 'NoPaymentId' });
      await router.push({ name: 'PurchaseErrorPage' });
      return;
    }
    try {
      const paymentResponse = await BillyApi.receiveVoucherByPaymentRecordId(paymentRecordId);
      if (paymentResponse.status === 'SUCCESS') {
        this.voucher = paymentResponse;
      } else if (paymentResponse.status === 'CUSTOMER_REJECTED') {
        await router.push({ name: 'SuperDiscountV2' });
      } else {
        await router.push({ name: 'PurchaseErrorPage' });
      }
    } catch (e) {
      Segment.trackUserGot('RamiLevi_PurchaseCompleted_Error', { errorType: 'BackendError' });
      await router.push({ name: 'PurchaseErrorPage' });
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal', 'closeModal']),
    ...mapActions('appHeader', ['resetAppHeaderProps']),

    readMore() {
      Segment.trackUserInteraction('HowToUseRamiLeviVoucher_Clicked');
      window.open('https://tav.rami-levy.co.il/', '_blank');
    },
  },
  watch: {
    loading() {
      if (!this.loading) {
        this.closeModal();
      }
    },
  },

};
</script>

<style lang="scss" scoped>
@import "~@riseupil/base-ui/src/scss/riseup-colors";

.voucher-card {
  background-color: $riseup_light_green;
  border-radius: 16px;
  width: 100%;

  .voucher-code {
    border-radius: 8px;
    height: 60px;
    background-color: $riseup_white;

    .voucher {
      font-family: SimplerPro, sans-serif;
      font-size: 32px;
      line-height: 46px;
      font-weight: 400;
      max-width: 220px;

      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}

.link {
  color: $riseup_blue;
  cursor: pointer;
}

</style>
